const booleanFromEnv = (value: string | undefined, fallback: boolean): boolean => {
  if (value === undefined) return fallback;
  return value.toLowerCase() === "true";
};

export const env = Object.freeze({
  appName: import.meta.env.VITE_APP_NAME ?? "EVzone Media & Content Platform",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "/api/v1",
  creatorProxyUrl:
    import.meta.env.VITE_CREATOR_PROXY_URL ?? "http://localhost:4010",
  routerMode: import.meta.env.VITE_ROUTER_MODE === "hash" ? "hash" : "browser",
  debug: booleanFromEnv(import.meta.env.VITE_DEBUG, false),
  environment: import.meta.env.MODE ?? "development",
});
